import { commonHeader, generateEndpoint } from "~/config/apiConfig";
import { ErrorBoundary } from "~/errors/errorBoundary";
import type { ConsumeChatRequestResult } from "~/interface/chatRequest";

export class ChatRequestApi {
  private getRequestInfo(method: string, requestBody?: object): RequestInit {
    return {
      method,
      headers: commonHeader,
      credentials: "include",
      keepalive: true,
      ...(requestBody ? { body: JSON.stringify(requestBody) } : {}),
    };
  }

  async consume(
    organization_id: string,
    project_id: string,
  ): Promise<ConsumeChatRequestResult | null> {
    const endpoint = generateEndpoint(
      `/organizations/${organization_id}/projects/${project_id}/chat-requests/consume`,
    );

    try {
      const requestInfo = this.getRequestInfo("POST");
      const response = await fetch(endpoint, requestInfo);
      if (response.ok) {
        const result: ConsumeChatRequestResult = await response.json();
        return result;
      } else if (response.status === 401) {
        // セッション切れ時はリダイレクトせず null を返す（呼び出し元でエラーメッセージ表示）
        console.warn("ChatRequestApi.consume: session expired (401)");
        return null;
      } else {
        const errorMessage = ErrorBoundary(response.status);
        console.error("ChatRequestApi.consume error:", errorMessage);
        return null;
      }
    } catch (error) {
      console.error("ChatRequestApi.consume unexpected error:", error);
      return null;
    }
  }

  async failure(organization_id: string, project_id: string): Promise<boolean> {
    const endpoint = generateEndpoint(
      `/organizations/${organization_id}/projects/${project_id}/chat-requests/failure`,
    );

    try {
      const requestInfo = this.getRequestInfo("POST");
      const response = await fetch(endpoint, requestInfo);
      if (response.ok) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("ChatRequestApi.failure unexpected error:", error);
      return false;
    }
  }
}
